const FIND_TAX = 'TAXES/FIND_TAX/FETCH'
const FIND_TAX_SUCCESS = 'TAXES/FIND_TAX/SUCCESS'
const FIND_TAX_ERROR = 'TAXES/FIND_TAX/ERROR'

export default { FIND_TAX, FIND_TAX_SUCCESS, FIND_TAX_ERROR }
